import styled from "styled-components";

export const Container = styled.div`
  .dropdown-menu {
    width: 35rem;
    max-width: 90vw;
    overflow-y: auto;
    max-height: 40rem;
  }
`;

export { BellButton, NotifBadge } from "../../styles";
